module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/capone360.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/capone360.png
// module id = 1158
// module chunks = 0